module.exports = __webpack_public_path__ + "static/media/lds-logo_el.148dcd97.svg";